export default class ConsoleRunner {
    runJS(script, vars, label = 'unknown') {
        let keys = Object.keys(vars)
        let values = Object.values(vars)

        try {
            // Get the native AsyncFunction constructor via new Function() so that the
            // project's own Babel transforms (which convert async function → generator)
            // cannot affect it. Code inside a string is never transformed by Babel.
            const AsyncFunction = new Function('return (async function(){}).constructor')()
            
            let result = new AsyncFunction(...keys, `
                try {
                    ${script}
                    // Return exports if they exist
                    if (typeof exports !== 'undefined') {
                        return exports.default || exports;
                    }
                } catch (e) {
                    e.message = '[${label}] ' + e.message + '\\nScript snippet: ' + ${JSON.stringify(script.substring(0, 200))};
                    
                    console.error(e);
                    throw e;
                }
            `)

            const results = result(...values)

            return results
        } catch (error) {
            // This catches errors in Function construction or execution
            error.message = `[${label}] JS execution failed: ${error.message}\nScript snippet: ${script.substring(0, 200)}...`

            console.log(error)

            throw error
        }
    }
}
